import React, { useEffect } from "react";
import ellipimg from "../../../images/Ellipse3.png";
import tb1 from "../../../images/tb1.png";
import tb2 from "../../../images/tb2.png";
import img1500 from "../../../images/img1500.png";
import ellp1 from "../../../images/Ellipse1.png";
import ellp2 from "../../../images/Ellipse2.png";
import rightimg from "../../../images/right.png";
import qwimg from "../../../images/qw.png";
import { useNavigate } from "react-router-dom";
import History from "../View-history/history";
import { useDispatch, useSelector } from "react-redux";
import {
  All_Progress,
  leastapi,
  list_quiz,
  View_Answer,
} from "../../../redux/authslice";
import Dashchart from "../../../componenet/dashchart";

export const SectionSecond = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const listquiz = useSelector((state) => state.counter.listquizs);
  const allDatas = useSelector((state) => state.counter.overData);
  const leastdata = useSelector((state) => state.counter.leastdata);

  const quizArray = [1, 10, 50, 100, 200, 300, 400, 500, 1000];
  const x = allDatas?.completed_quizzes;

  let token = localStorage?.getItem("token");

  const viewQuiz = (data) => {
    dispatch(View_Answer({ id: data.id, navigate, dispatch }));
  };

  useEffect(() => {
    if (token) {
      dispatch(All_Progress(dispatch));
      dispatch(list_quiz(dispatch));
      dispatch(leastapi(dispatch));
    }
  }, [token]);
  return (
    <section className="foundation-all">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6">
            {quizArray?.includes(x) && (
              <>
                <div className="track">
                  <p className="track-head">Track your progress</p>
                </div>
                <div
                  className="exceptional-box"
                  onClick={() => navigate("/history")}
                >
                  <img src={rightimg} className="right-img" alt="" />
                  <img src={qwimg} className="right-img1" alt="" />
                  <div className="exceptional">
                    <p className="exceptional-no">{x}</p>
                    <button className="quizzes-btn">Quizzes completed</button>
                  </div>
                  <p className="exception-head1">Exceptional milestone!</p>
                  <p className="exception-head2">
                    Congratulations on achieving this milestone
                  </p>
                </div>
              </>
            )}
            {leastdata?.name === undefined || leastdata?.name === null ? (
              ""
            ) : (
              <div className="exceptional-box1">
                <div className="exceptional1">
                  <p className="exceptional-no1">{leastdata?.score}</p>
                  <button className="quizzes-btn1">{leastdata?.name}</button>
                </div>
                <p className="exception-head11">Keep practising!</p>
                <p className="exception-head22">
                  Improve your confidence in {leastdata?.name} by practicing
                  another quiz{" "}
                </p>
                <div className="new-quiz">
                  <button
                    className="New-quiz"
                    onClick={() => navigate("/quizgenerator")}
                  >
                    New quiz
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-6">
            <div className="overall">
              <p className="overall-title">Overall quiz performance</p>
              <Dashchart allDatas={allDatas} />
              <div className="circle-col" style={{ marginBottom: 15 }}>
                <div className="circle">
                  <img className="circle-img" src={ellp2} alt="" />
                  <div className="circle-pra">
                    <p className="circle-title">Completed</p>
                    <p className="circle-subtitle">
                      {allDatas?.completed_quizzes}/{allDatas?.total_quizes}
                    </p>
                  </div>
                </div>
                <div className="circle">
                  <img className="circle-img" src={ellp2} alt="" />
                  <div className="circle-pra">
                    <p className="circle-title">In progress</p>
                    <p className="circle-subtitle">
                      {allDatas?.in_progress_quizzes}/{allDatas?.total_quizes}
                    </p>
                  </div>
                </div>
              </div>
              <div className="circle-col">
                <div className="circle">
                  <img className="circle-img" src={ellipimg} alt="" />
                  <div className="circle-pra">
                    <p className="circle-title">Scores over 90%</p>
                    <p className="circle-subtitle">
                      {allDatas?.over_90}/{allDatas?.total_quizes}
                    </p>
                  </div>
                </div>
                <div className="circle" style={{ visibility: "hidden" }}>
                  <img className="circle-img" src={ellp1} alt="" />
                  <div className="circle-pra">
                    <p className="circle-title">Completed</p>
                    <p className="circle-subtitle">375/1500</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="table-section">
        <div className="table-title">
          <p className="table-title1">Quiz history</p>
          <p className="table-title2">
            <a href="/history">View all</a>
          </p>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="border-tbl">
              {/* <div class="row">
              <div class="col-lg-6">
                <div class="left-his">
                  <div class="search-34">
                    <input type="search" placeholder="Search for quiz name, answer" class="search-12">
                    <img src="images/Search.png" class="Search-img" alt="">
                  </div>
                  <button class="search-bt">Search</button>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="right-his">
                  <div class="select-div">
                    <p class="View-90">View</p>
                    <select name="" id="">
                      <option value="">7 rows</option>
                      <option value="">6 rows</option>
                      <option value="">5 rows</option>
                    </select>
                  </div>
                </div>
              </div>
            </div> */}

              <div className="col-lg-12">
                <div className="table-div-scrol">
                  <table>
                    <thead>
                      <tr>
                        <th>Subject</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody className="cursor-pointer">
                      {listquiz?.length === 0 ? (
                        <tr>
                          <td colSpan="9" style={{ textAlign: "center" }}>
                            No data
                          </td>
                        </tr>
                      ) : (
                        listquiz?.slice(0, 5).map((quiz, index) => (
                          <tr
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() => viewQuiz(quiz)}
                          >
                            <td>{quiz?.name}</td>
                            <td>
                              {quiz?.completion_date
                                ? new Date(
                                    quiz?.completion_date * 1000
                                  ).toLocaleDateString()
                                : "N/A"}
                            </td>

                            <td>
                              {quiz?.completion_date
                                ? new Date(
                                    quiz.completion_date * 1000
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                                : "N/A"}
                            </td>
                            <td>
                              <p
                                className="Completed-p"
                                style={{
                                  color:
                                    quiz?.status === "Completed"
                                      ? "green"
                                      : "red",
                                }}
                              >
                                {quiz?.status}
                              </p>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
